import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { AppHeader } from "../../components/header/header";
import { BodySpacer } from "../../components/utilities/body-spacer";
import { ChooseCountry } from "../../components/countries/countries";
import { AppFooter } from "../../components/footer/footer";
import { PageCaptionImage } from "../../components/page-components/page-caption-box";

import "../../styles/visa.css";

export const VisaPage = () => {

    const country = useLocation()?.state?.country;

    const [ctry, setCtry] = useState('Belgium');

    useEffect(() => {
        country ? setCtry(country): setCtry('Belgium')
    },[country]);

    return (
        <div className="page-body">
            <AppHeader />
            <BodySpacer />
            <PageCaptionImage
                caption={"VISA"}
                caption1={"PROGRAMS"}
                imageUrl={'/images/passport-visa.jpg'} 
            />
            <div className='visa-page'>
                <div className="choose-ctry">
                    <ChooseCountry 
                        nav={false}
                        action={(v) => setCtry(v)}
                    />
                </div>
                <div className="ctry-det-box">
                    <div className="ctry-caption">{ctry}</div>
                    <div className="ctry-img">
                        <img src={`./images/places/${ctry.toLocaleLowerCase()}.jpg`} className="ctry-pic" alt=""/>
                    </div>
                </div>
            </div>
           <AppFooter />
        </div>
    )
}